export default __webpack_public_path__ + "static/cloud-hero-img-1d51e1bcf96d1fdc45492330cc285cfe.png";